export function compararArrayOptions(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].value !== arr2[i].value) {
            return false;
        }
    }

    return true;
}

export function filtrosToString(filtros) {
    let resp = `?`;

    if (filtros.fecAlt) resp += `fecAltDesdeDate=${filtros.fecAlt.desde.toISOString()}&fecAltHastaDate=${filtros.fecAlt.hasta.toISOString()}&dateOfIssueDesdeDate=${filtros.dateOfIssue.desde.toISOString()}&dateOfIssueHastaDate=${filtros.dateOfIssue.hasta.toISOString()}`

    return resp;
}

export function filtrosSolicitudToString(filtros) {
    let resp = `?`;

    if (filtros.fecAlt) resp += `fecAltDesdeDate=${filtros.fecAlt.desde.toISOString()}&fecAltHastaDate=${filtros.fecAlt.hasta.toISOString()}`

    return resp;
}

export function getMimeTypeByExtension(filename) {
    const ext = filename.split('.').pop().toLowerCase();

    switch (ext) {
        case 'pdf':
            return 'application/pdf';
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
        default:
            return 'application/octet-stream'; // fallback genérico
    }
}

export function formatCuitGuiones(cuit) {
    return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
}

export function formatCuitPuntos(cuit) {
    return `${cuit.slice(0, 2)}.${cuit.slice(2, 10)}.${cuit.slice(10)}`;
}

export function formatCuitGuionPunto(cuit) {
    return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}.${cuit.slice(10)}`;
}

export function formatCuitPuntoGuion(cuit) {
    return `${cuit.slice(0, 2)}.${cuit.slice(2, 10)}-${cuit.slice(10)}`;
}